<template lang="pug">
.event-target-select-modal
  b-modal(v-model="_value" size="md" no-close-on-backdrop no-close-on-esc @ok="ok" @cancel="cancel")
    template(v-slot:modal-title)
      span {{ headerTitle }}を選択してください。

    b-card-group
      b-card.align-self-start(no-body)
        span.event-target-header(slot="header") {{ headerTitle }}
        b-list-group(flush)
          b-list-group-item(v-for="group in selectOptions" :key="group.id")
            b-form-checkbox(v-model="group.isChecked")
              span {{ group.name }}

    div(slot="modal-footer" slot-scope="{ ok, cancel }")
      button.btn.modal-ok-btn(v-if="_checked" type="button" @click="ok()") OK
      button.btn.modal-ok-btn.disable(v-else type="button" disabled) OK
      button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### イベント宛先選択モーダル
 */
@Component
export default class EventTargetSelectModal extends Vue {
  @Prop({ required: true })
  value!: boolean;

  /** 宛先対象リスト */
  @Prop({ required: true })
  selectOptions!: Array<EventTargetSelectModalModel>;

  /** ヘッダータイトル */
  @Prop({
    default: () => {
      return "宛先";
    }
  })
  headerTitle!: string;

  get _checked(): boolean {
    for (const target of this.selectOptions) {
      if (target.isChecked == true) {
        return true;
      }
    }

    return false;
  }

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  /**
   * ### OKボタン押下イベント
   *
   * - 親コンポーネントに入力情報を通知する
   */
  public ok(): void {
    this.$emit("ok", this.selectOptions);

    return;
  }

  /**
   * ### キャンセルボタン押下イベント
   *
   * - 入力した内容を全て破棄する
   * - 親コンポーネントに通知する
   */
  public cancel(): void {
    this.$emit("cancel");

    return;
  }
}

export interface EventTargetSelectModalModel {
  name: string;
  id: number;
  isChecked: boolean;
}
</script>

<style lang="scss">
.event-target-header {
  font-size: 16px;
  font-weight: bold;
}
</style>
